import React, { useEffect, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import MdlOldDueCollectionConfirmation from "../dialog/MdlOldDueCollectionConfirmation";
import MdlOldDuePaymentStatus from "../dialog/MdlOldDuePaymentStatus";
import BackButton from "../ChildComponent/BackButton";

// Helper to calculate remaining due for a single item
// Formula (as requested): Due = total - paid - settled
const calculateDue = (amount, paid, settled) => {
  const mAmount = Number(amount) || 0;
  const mPaid = Number(paid) || 0;
  const mSettled = Number(settled) || 0;
  return Math.max(0, mAmount - mPaid - mSettled);
};

const OldDueCollection = () => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [showFeeConfirmation, setShowFeeConfirmation] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingDue, setEditingDue] = useState(null);
  const [editAmount, setEditAmount] = useState("");
  const [editRemark, setEditRemark] = useState("");
  const [showSettleModal, setShowSettleModal] = useState(false);
  const [settlingDue, setSettlingDue] = useState(null);
  const [settleAmount, setSettleAmount] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [mDueList, setDueList] = useState([]);
  const [mDueData, setDueData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [otherAmount, setOtherAmount] = useState("");
  const [showPaymentStatus, setShowPaymentStatus] = useState(false);
  const [lastTransactionId, setLastTransactionId] = useState("");
  const [lastCollectedAmount, setLastCollectedAmount] = useState(0);

  const { student_id, session_id } = useParams();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
      return;
    }
    if (student_id && session_id) {
      StudentDetails();
    }
  }, [student_id, session_id]);

  useEffect(() => {
    if (selectedStudent) {
      getStudentOldDue();
    }
  }, [selectedStudent]);

  useEffect(() => {
    getDueList();
  }, [mDueData]);

  // Recalculate totalPayableAmount whenever due list changes
  useEffect(() => {
    const total = mDueList.reduce((sum, item) => {
      if (item.checked) {
        const payable = item.payable_amount !== undefined 
          ? Number(item.payable_amount) || 0
          : calculateDue(item.amount, item.amount_paid, item.settled_amount);
        return sum + payable;
      }
      return sum;
    }, 0);
    setTotalPayableAmount(total);
  }, [mDueList]);

  const getDueList = () => {
    const dueList = mDueData
      .filter((item) => {
        const due = calculateDue(item.amount, item.amount_paid, item.settled_amount);
        return due !== 0;
      })
      .map((item) => {
        const amount = Number(item.amount) || 0;
        const settled = Number(item.settled_amount) || 0;
        const paid = Number(item.amount_paid) || 0;
        const totalDue = calculateDue(amount, paid, settled);
        return {
          ...item,
          amount: amount,
          settled_amount: settled,
          amount_paid: paid,
          payable_amount: totalDue, // Initialize payable_amount as number (amount - settled)
          checked: item.checked || false, // Preserve checked state if exists
        };
      });
    setDueList(dueList);

    const total = dueList.reduce(
      (acc, item) =>
        acc + calculateDue(item.amount, item.settled_amount, item.amount_paid),
      0
    );
    setTotalAmount(total);
    
    // Reset other amount when due list changes
    setOtherAmount("");
  };

  const StudentDetails = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const Adhar_ID = "";
    const FUNCTION_NAME = "searchStudentDetails.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: SCHOOL_CODE,
      enrollment_no: student_id,
      session_id: session_id,
      aadhar_no: Adhar_ID,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && response.data?.length > 0) {
          //console.log(JSON.stringify(response.data[0]));
          setSelectedStudent(response.data[0]);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Fetch Error:", error);
      });
  };

  const getStudentOldDue = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getStudentOldDue.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: SCHOOL_CODE,
      enrollment_no: student_id,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && response.data?.length > 0) {
          // console.log(JSON.stringify(response.data));
          const formattedData = response.data.map((item) => {
            // Use settled_amount as the authoritative source for remaining due calculation
            // settled_amount includes both collection (amount_paid) and settlement amounts
            const settledAmount = Number(item.settled_amount) || 0;
            const amountPaid = Number(item.amount_paid) || 0;
            const totalAmount = Number(item.amount) || 0;
            const payableAmount = calculateDue(totalAmount, amountPaid, settledAmount);
            return {
            ...item, // retain existing fields
              settled_amount: settledAmount, // Use settled_amount from database
              amount_paid: amountPaid, // Keep amount_paid as separate field for display
              payable_amount: payableAmount, // Amount that can still be paid
              checked: false, // Initialize checked property
            };
          });
          console.log("getStudentOldDue - Formatted data:", formattedData);
          setDueData(formattedData);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Fetch Error:", error);
      });
  };

  const handleCheckboxClick = (index) => {
    setDueList((prevList) => {
      const newList = [...prevList];
      const item = { ...newList[index] };
      const totalDue = calculateDue(item.amount, item.amount_paid, item.settled_amount);

      if (item.checked) {
        // Unchecking: reset to full due amount
        item.checked = false;
        item.payable_amount = totalDue; // Reset to full due amount (as number)
        // Clear other amount if all items are unchecked
        if (newList.every((i, idx) => idx === index || !i.checked)) {
          setOtherAmount("");
        }
      } else {
        // Checking: use full due amount (manual selection)
        item.checked = true;
        item.payable_amount = totalDue; // Use full due amount for manual selection (as number)
        // Clear other amount when manually selecting
        setOtherAmount("");
      }

      newList[index] = item;
      return newList;
    });
  };
  const handleSettleSingleDue = (item, index) => {
    const dueAmount = calculateDue(item.amount, item.amount_paid, item.settled_amount);
    if (dueAmount <= 0) {
      myToast.notify_warning("This due is already fully paid");
      return;
    }
    
    setSettlingDue(item);
    setSettleAmount(dueAmount.toString());
    setShowSettleModal(true);
  };

  const handleCloseSettleModal = () => {
    setShowSettleModal(false);
    setSettlingDue(null);
    setSettleAmount("");
  };

  const handleSubmitSettle = () => {
    if (!settlingDue) return;
    
    const amount = parseFloat(settleAmount);
    const totalAmount = Number(settlingDue.amount) || 0;
    const settled = Number(settlingDue.settled_amount) || 0;
    // Due = total amount - settled amount (settled_amount includes both collection and settlement)
    const maxAmount = Math.max(0, totalAmount - settled);
    
    if (isNaN(amount) || amount <= 0) {
      myToast.notify_warning("Please enter a valid amount");
      return;
    }
    
    if (amount > maxAmount) {
      myToast.notify_warning(`Amount cannot exceed remaining due of ₹${maxAmount.toLocaleString()}`);
      return;
    }
    
    settleOldDue(settlingDue, amount, "");
    handleCloseSettleModal();
  };

  const settleOldDue = (item, amount, remark) => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    var mStaffData = SessionManager.getStaffDetails();
    var STAFF_ID = mStaffData.staff_id;
    const classDetails = selectedStudent?.class?.[0] || {};
    
    const FUNCTION_NAME = "SettleOldDue.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      student_id: student_id,
      class_id: classDetails.class_id || "",
      section_id: classDetails.section_id || "",
      session_id: classDetails.session_id || session_id,
      staff_id: STAFF_ID,
      due_id: item.due_id, // due_id from tm_fee_old_due_student table
      amount: amount,
      remark: remark || "Fee payment",
      school_code: SCHOOL_CODE,
    };

    console.log("settleOldDue - Params:", params);
    console.log("settleOldDue - URL:", URL);

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        console.log("settleOldDue - Response:", response);
        if (response.api_status === "OK") {
          myToast.notify_success("Due settled successfully");
          // Reset selections
          setTotalPayableAmount(0);
          // Refresh the due list
          if (selectedStudent) {
            getStudentOldDue();
          }
        } else {
          myToast.notify_warning(response.api_remark || "Failed to settle due");
          console.error("settleOldDue - Error response:", response);
        }
      })
      .catch((error) => {
        setLoading(false);
        myToast.notify_error("Error settling due: " + (error.response?.data?.api_remark || error.message));
        console.error("Settle Error:", error);
        if (error.response) {
          console.error("Settle Error Response:", error.response.data);
        }
      });
  };

  const handleEditDue = (item, index) => {
    setEditingDue(item);
    setEditAmount(item.amount.toString());
    setEditRemark(item.remark || "");
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingDue(null);
    setEditAmount("");
    setEditRemark("");
  };

  const handleSubmitEdit = () => {
    if (!editingDue) return;
    
    const amount = parseFloat(editAmount);
      if (isNaN(amount) || amount <= 0) {
        myToast.notify_warning("Please enter a valid amount");
        return;
      }
      
    if (!editRemark.trim()) {
      myToast.notify_warning("Please enter a remark");
      return;
    }
    
    updateOldDue(editingDue, amount, editRemark.trim());
    handleCloseEditModal();
  };

  const updateOldDue = (item, newAmount, remark) => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "updateOldDue.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      school_code: SCHOOL_CODE,
      enrollment_no: student_id,
      due_id: item.due_id, // due_id from tm_fee_old_due_student table
      amount: newAmount,
      remark: remark || item.remark || "",
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Due updated successfully");
          // Refresh the due list
          if (selectedStudent) {
            getStudentOldDue();
          }
        } else {
          myToast.notify_warning(response.api_remark || "Failed to update due");
        }
      })
      .catch((error) => {
        setLoading(false);
        myToast.notify_error("Error updating due");
        console.error("Update Error:", error);
      });
  };

  const handleDeleteDue = (item, index) => {
    if (window.confirm(`Are you sure you want to delete this due entry?\nSession: ${item.session_name}\nAmount: ₹${item.amount}`)) {
      deleteOldDue(item);
    }
  };

  const deleteOldDue = (item) => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    var mStaffData = SessionManager.getStaffDetails();
    var STAFF_ID = mStaffData.staff_id;
    const classDetails = selectedStudent?.class?.[0] || {};
    
    const FUNCTION_NAME = "deleteOldDue.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      staff_id: STAFF_ID,
      session_id: classDetails.session_id || session_id,
      student_id: student_id,
      old_due_id: item.due_id, // due_id from tm_fee_old_due_student table
      amount: item.amount,
      school_code: SCHOOL_CODE,
    };

    // Build full URL with parameters for logging
    const queryString = new URLSearchParams(params).toString();
    const fullURL = URL + queryString;
    console.log("deleteOldDue - Full URL:", fullURL);
    console.log("deleteOldDue - Params:", params);

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Due deleted successfully");
          // Refresh the due list
          if (selectedStudent) {
            getStudentOldDue();
          }
        } else {
          myToast.notify_warning(response.api_remark || "Failed to delete due");
        }
      })
      .catch((error) => {
        setLoading(false);
        myToast.notify_error("Error deleting due");
        console.error("Delete Error:", error);
      });
  };

  const handleSubmitfee = () => {
    if (totalPayableAmount === 0) {
      myToast.notify_warning("Please select at least one due to collect!");
    } else {
      setShowFeeConfirmation(true);
    }
  };
  const HandleClose = () => {
    setShowFeeConfirmation(false);
  };

  const HandleSubmit = (collectionDate, paymentMode, paymentRemark) => {
    setShowFeeConfirmation(false);
    submitFeeCollection(collectionDate, paymentMode, paymentRemark);
  };

  const submitFeeCollection = (collectionDate, paymentMode, paymentRemark) => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    var mStaffData = SessionManager.getStaffDetails();
    var STAFF_ID = mStaffData.staff_id;
    const remark = paymentRemark || "Fee payment";
    const selected_due = mDueList.filter(
      (item) => item.checked === true || item.checked === "true"
    );
    
    // Recalculate amount from selected items to ensure accuracy
    const calculatedAmount = selected_due.reduce((total, item) => {
      // Use payable_amount if it's defined, otherwise calculate from total - paid - settled
      const payableAmount = item.payable_amount !== undefined 
        ? Number(item.payable_amount) || 0
        : calculateDue(item.amount, item.amount_paid, item.settled_amount);
      return total + payableAmount;
    }, 0);
    
    const str_fee_details = JSON.stringify(selected_due);
    const classDetails = selectedStudent?.class?.[0] || {};

    const FUNCTION_NAME = "submitOldDueCollection.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      student_id: student_id,
      class_id: classDetails.class_id || "",
      section_id: classDetails.section_id || "",
      session_id: classDetails.session_id || session_id,
      staff_id: STAFF_ID,
      fee_details: str_fee_details,
      remark: remark,
      amount: calculatedAmount,
      school_code: SCHOOL_CODE,
      payment_mode: paymentMode || null,
      collection_date: collectionDate || null,
    };
    
    console.log("submitFeeCollection - Selected items:", selected_due);
    console.log("submitFeeCollection - Calculated amount:", calculatedAmount);
    console.log("submitFeeCollection - State totalPayableAmount:", totalPayableAmount);
    const queryString = new URLSearchParams(params).toString();
    //console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Submitted Successfully");

          // Store transaction info for payment status dialog
          const txnId = response.transaction_id || "";
          setLastTransactionId(txnId);
          setLastCollectedAmount(calculatedAmount);
          setShowPaymentStatus(true);

          // Reset list; fresh data will come after closing dialog if needed
          setTotalPayableAmount(0);
          setDueData([]);
          setDueList([]);

          // Optionally refresh dues in background
          getStudentOldDue();
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Fetch Error:", error);
      });
  };

  const handleOtherAmountChange = (value) => {
    const amount = parseFloat(value) || 0;
    setOtherAmount(value);

    if (amount <= 0) {
      // Reset all checkboxes if amount is 0 or invalid
      setDueList((prevList) => {
        return prevList.map((item) => {
          return {
            ...item,
            checked: false,
            payable_amount: calculateDue(
              item.amount,
              item.amount_paid,
              item.settled_amount
            ),
          };
        });
      });
      return;
    }

    // Validate amount doesn't exceed total due
    if (amount > totalAmount) {
      myToast.notify_warning(`Amount cannot exceed total due of ₹${totalAmount.toLocaleString()}`);
      return;
    }

    // Distribute amount across dues in order
    let remainingAmount = amount;

    setDueList((prevList) => {
      const newList = prevList.map((item) => {
        const dueAmount = calculateDue(
          item.amount,
          item.amount_paid,
          item.settled_amount
        );
        
        if (remainingAmount <= 0) {
          // No more amount to distribute, uncheck this item
          return {
            ...item,
            checked: false,
            payable_amount: dueAmount,
          };
        }

        if (remainingAmount >= dueAmount) {
          // Full amount for this due
          const payable = dueAmount;
          remainingAmount -= payable;
          return {
            ...item,
            checked: true,
            payable_amount: payable, // Store as number
          };
        } else {
          // Partial amount for this due
          const payable = remainingAmount;
          remainingAmount = 0;
          return {
            ...item,
            checked: true,
            payable_amount: payable, // Store as number
          };
        }
      });

      return newList;
      });
  };

  const collectByOtherAmount = () => {
    // Keep the navigation for now, but we'll replace the UI with input
    // history.push("/AdminMain/OldDueOtherAmount");
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  const classDetails = selectedStudent?.class?.[0] || {};

  return (
    <div className="content">
      <div className="content-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" aria-hidden="true" />
              <a href="#">Old Due Collection</a>
            </li>
          </ul>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <BackButton />
        </div>
      </div>

      <div
        className="bg_page_white_rounded box_shadow animated fadeInUp"
        style={{ "--mMargin": "30px", padding: "24px" }}
      >
        {/* Modern Student Profile Section */}
        {selectedStudent && (
          <div style={{
            background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey1 || "#F5F5F5"} 100%)`,
            border: `2px solid ${COLORS.primary_color_shade6 || "#039BE5"}`,
            borderRadius: "16px",
            padding: "24px",
            marginBottom: "24px",
            boxShadow: `0 4px 16px rgba(0, 0, 0, 0.08)`,
            position: "relative",
            overflow: "hidden",
          }}>
            {/* Decorative elements */}
            <div style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "200px",
              height: "200px",
              background: "rgba(11, 181, 244, 0.05)",
              borderRadius: "50%",
              filter: "blur(40px)",
            }}></div>

            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
              position: "relative",
              zIndex: 1,
            }}>
              {/* Student Image */}
              <div style={{ position: "relative" }}>
                <div style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  border: `4px solid ${COLORS.primary_color_shade6 || "#039BE5"}`,
                  padding: "4px",
                  background: COLORS.white,
                  boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                }}>
                  <img 
                    src={selectedStudent?.student_img_path || ""} 
                    alt={selectedStudent?.stu_name || "Student"} 
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                      if (!e.target.nextSibling) {
                        const fallback = document.createElement("div");
                        fallback.style.cssText = `
                          width: 100%;
                          height: 100%;
                          border-radius: 50%;
                          background: linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade4} 100%);
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: #fff;
                          font-size: 32px;
                          font-weight: 700;
                        `;
                        fallback.textContent = selectedStudent?.stu_name?.charAt(0)?.toUpperCase() || "S";
                        e.target.parentNode.appendChild(fallback);
                      }
                    }}
                  />
                </div>
                <div style={{
                  position: "absolute",
                  bottom: "0",
                  right: "0",
                  background: COLORS.primary_color_shade6 || "#039BE5",
                  color: COLORS.white,
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "11px",
                  fontWeight: "600",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                  border: "2px solid #fff",
                }}>
                  {selectedStudent?.student_enrollment_no || ""}
                </div>
              </div>

              {/* Student Details */}
              <div style={{ flex: 1 }}>
                <h4 style={{
                  margin: "0 0 12px 0",
                  fontSize: "22px",
                  fontWeight: "700",
                  color: COLORS.black8 || "#333333",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}>
                  <i className="fa fa-user" style={{ color: COLORS.primary_color_shade6, fontSize: "18px" }} />
                  {selectedStudent?.stu_name || ""}
                </h4>
                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  marginBottom: "12px",
                }}>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 12px",
                    background: COLORS.primary_color_shade1 || "#B3E5FC",
                    borderRadius: "8px",
                    border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                  }}>
                    <i className="fa fa-user-circle" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "12px" }} />
                    <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                      Father: {selectedStudent?.father_name || ""}
                    </span>
                  </div>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 12px",
                    background: COLORS.primary_color_shade1 || "#B3E5FC",
                    borderRadius: "8px",
                    border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                  }}>
                    <i className="fa fa-graduation-cap" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "12px" }} />
                    <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                      {classDetails?.class_name || ""}
                    </span>
                  </div>
                  {classDetails?.board_name && (
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "6px 12px",
                      background: COLORS.primary_color_shade1 || "#B3E5FC",
                      borderRadius: "8px",
                      border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                    }}>
                      <i className="fa fa-book" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "12px" }} />
                      <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                        {classDetails?.board_name} {classDetails?.medium_name && `- ${classDetails.medium_name}`}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Roll No & Due Amount */}
              <div style={{
                textAlign: "center",
                padding: "16px 24px",
                background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
                borderRadius: "12px",
                color: COLORS.white,
                boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                minWidth: "140px",
              }}>
                <div style={{ marginBottom: "12px" }}>
                  <p style={{ margin: "0 0 4px 0", fontSize: "12px", opacity: 0.9 }}>Roll No.</p>
                  <h4 style={{ margin: 0, fontSize: "24px", fontWeight: "700" }}>
                    {classDetails?.student_roll_no || ""}
                  </h4>
                </div>
                <div style={{
                  paddingTop: "12px",
                  borderTop: "1px solid rgba(255, 255, 255, 0.3)",
                }}>
                  <p style={{ margin: "0 0 4px 0", fontSize: "12px", opacity: 0.9 }}>Total Due</p>
                  <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
                    ₹{totalAmount.toLocaleString()}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        )}

        <section style={{ marginTop: "24px" }}>
          <h4 style={{
            marginBottom: "20px",
            fontSize: "18px",
            fontWeight: "600",
            color: COLORS.black8 || "#333333",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}>
            <i className="fa fa-list" style={{ color: COLORS.primary_color_shade6 }} />
            Due List ({mDueList.length})
          </h4>
          
          {mDueList.map((item, index) => {
            const totalAmount = Number(item.amount) || 0;
            const settled = Number(item.settled_amount) || 0;
            const paid = Number(item.amount_paid) || 0;
            // Due = total - paid - settled (where settled = settled_amount - amount_paid)
            const settledOnly = Math.max(0, settled - paid); // Settlement amount only (excluding collection)
            const totalDueAmount = Math.max(0, totalAmount - paid - settledOnly);
            const payableAmount = item.payable_amount !== undefined ? item.payable_amount : totalDueAmount;
            const dueAmount = payableAmount; // Use payable_amount if set, otherwise use total due
            const isPartialPayment = item.checked && payableAmount < totalDueAmount;
            return (
              <div key={index} style={{
                background: COLORS.white,
                border: `2px solid ${item.checked ? COLORS.primary_color_shade6 : COLORS.grey3 || "#E0E0E0"}`,
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "16px",
                boxShadow: item.checked 
                  ? `0 4px 12px ${COLORS.primary_color_shade3}40` 
                  : "0 2px 8px rgba(0, 0, 0, 0.08)",
                transition: "all 0.3s ease",
                position: "relative",
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}>
                  {/* Checkbox */}
                  <div style={{
                    marginTop: "4px",
                  }}>
                    <input
                      type="checkbox"
                      id={`DueAmount${index}`}
                      checked={item.checked || false}
                      onChange={() => handleCheckboxClick(index)}
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        accentColor: COLORS.primary_color_shade6,
                      }}
                    />
                  </div>

                  {/* Due Details */}
                  <div style={{ flex: 1 }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginBottom: "12px",
                      flexWrap: "wrap",
                    }}>
                      <div style={{
                        padding: "8px 16px",
                        background: `linear-gradient(135deg, ${COLORS.red5 || "#f44336"} 0%, ${COLORS.red7 || "#d32f2f"} 100%)`,
                        borderRadius: "8px",
                        color: COLORS.white,
                        fontWeight: "700",
                        fontSize: "16px",
                        boxShadow: `0 2px 8px ${COLORS.red3}60`,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "2px",
                      }}>
                        <span>₹{dueAmount.toLocaleString()}</span>
                        {isPartialPayment && (
                          <span style={{ fontSize: "11px", opacity: 0.9 }}>
                            of ₹{totalDueAmount.toLocaleString()}
                          </span>
                        )}
                      </div>
                      <div style={{
                        padding: "6px 12px",
                        background: COLORS.primary_color_shade1 || "#B3E5FC",
                        borderRadius: "6px",
                        border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                      }}>
                        <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                          <i className="fa fa-calendar" style={{ marginRight: "6px", color: COLORS.primary_color_shade8 }} />
                          {item.session_name}
                        </span>
                      </div>
                    </div>

                    <div style={{
                      marginBottom: "8px",
                      padding: "8px 12px",
                      background: COLORS.grey1 || "#F5F5F5",
                      borderRadius: "6px",
                    }}>
                      <span style={{ fontSize: "13px", color: COLORS.black6 || "#666666" }}>
                        <strong>Remark:</strong> {item.remark || "N/A"}
                      </span>
                    </div>

                    <div style={{
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}>
                      <i className="fa fa-check-circle" style={{ color: COLORS.green4 || "#2C8D02" }} />
                      <span style={{ color: COLORS.black8 || "#333333", fontWeight: "600" }}>
                        Collected: <span style={{ color: COLORS.green4 || "#2C8D02", fontWeight: "700", fontSize: "14px" }}>₹{(Number(item.amount_paid) || 0).toLocaleString()}</span> / <span style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontWeight: "600" }}>₹{(Number(item.amount) || 0).toLocaleString()}</span>
                      </span>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    alignItems: "flex-end",
                  }}>
                    {/* Edit button - only enabled when collected amount is 0 */}
                    {(Number(item.settled_amount || 0) === 0) && (
                      <button
                        onClick={() => handleEditDue(item, index)}
                        style={{
                          padding: "8px 16px",
                          background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#039BE5"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
                          color: COLORS.white,
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          boxShadow: `0 2px 6px ${COLORS.primary_color_shade3}60`,
                          transition: "all 0.3s ease",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          whiteSpace: "nowrap",
                          width: "100%",
                          justifyContent: "center",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = `0 4px 10px ${COLORS.primary_color_shade4}80`;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "";
                          e.currentTarget.style.boxShadow = `0 2px 6px ${COLORS.primary_color_shade3}60`;
                        }}
                      >
                        <i className="fa fa-edit" />
                        Edit
                      </button>
                    )}
                    
                    {/* Delete button - only enabled when collected amount is 0 */}
                    {(Number(item.settled_amount || 0) === 0) && (
                      <button
                        onClick={() => handleDeleteDue(item, index)}
                        style={{
                          padding: "8px 16px",
                          background: `linear-gradient(135deg, ${COLORS.red5 || "#f44336"} 0%, ${COLORS.red7 || "#d32f2f"} 100%)`,
                          color: COLORS.white,
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          boxShadow: `0 2px 6px ${COLORS.red3}60`,
                          transition: "all 0.3s ease",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          whiteSpace: "nowrap",
                          width: "100%",
                          justifyContent: "center",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = `0 4px 10px ${COLORS.red4}80`;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "";
                          e.currentTarget.style.boxShadow = `0 2px 6px ${COLORS.red3}60`;
                        }}
                      >
                        <i className="fa fa-trash" />
                        Delete
                      </button>
                    )}
                    
                    {/* Settle Now button - always visible */}
                    <button
                      onClick={() => handleSettleSingleDue(item, index)}
                      style={{
                        padding: "10px 20px",
                        background: `linear-gradient(135deg, ${COLORS.green3 || "#38B503"} 0%, ${COLORS.green4 || "#2C8D02"} 100%)`,
                        color: COLORS.white,
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: `0 2px 8px ${COLORS.green2}60`,
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        whiteSpace: "nowrap",
                        width: "100%",
                        justifyContent: "center",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.green3}80`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.boxShadow = `0 2px 8px ${COLORS.green2}60`;
                      }}
                    >
                      <i className="fa fa-check-circle" />
                      Settle Now
                    </button>
                  </div>
                </div>
              </div>
            );
          })}

          <div style={{
            marginTop: "24px",
            padding: "20px",
            background: COLORS.white,
            border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
          }}>
            <h4 style={{
              marginBottom: "16px",
              fontSize: "16px",
              fontWeight: "600",
              color: COLORS.black8 || "#333333",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}>
              <i className="fa fa-calculator" style={{ color: COLORS.primary_color_shade6 }} />
              Collect By Other Amount
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: COLORS.black8 || "#333333",
                }}>
                  <i className="fa fa-rupee-sign" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Enter Amount (Max: ₹{totalAmount.toLocaleString()})
                </label>
                <input
                  type="number"
                  value={otherAmount}
                  onChange={(e) => handleOtherAmountChange(e.target.value)}
                  placeholder="Enter amount to collect"
                  min="0"
                  max={totalAmount}
              style={{
                    width: "100%",
                padding: "14px 16px",
                    fontSize: "16px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "10px",
                transition: "all 0.3s ease",
                    outline: "none",
                    boxSizing: "border-box",
              }}
                  onFocus={(e) => {
                e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
              }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
                {otherAmount && parseFloat(otherAmount) > totalAmount && (
                  <div style={{
                    marginTop: "8px",
                    padding: "8px 12px",
                    background: COLORS.red1 || "#FFEBEE",
                    border: `1px solid ${COLORS.red3 || "#EF5350"}`,
                    borderRadius: "6px",
                    color: COLORS.red7 || "#d32f2f",
                    fontSize: "13px",
                  }}>
                    <i className="fa fa-exclamation-circle" style={{ marginRight: "6px" }} />
                    Amount cannot exceed total due of ₹{totalAmount.toLocaleString()}
                  </div>
                )}
              </div>
              {otherAmount && parseFloat(otherAmount) > 0 && parseFloat(otherAmount) <= totalAmount && (
                <div style={{
                  padding: "12px",
                  background: COLORS.green1 || "#C8E6C9",
                  border: `1px solid ${COLORS.green3 || "#38B503"}`,
                  borderRadius: "8px",
                  fontSize: "13px",
                  color: COLORS.green4 || "#2C8D02",
                }}>
                  <i className="fa fa-info-circle" style={{ marginRight: "6px" }} />
                  <strong>₹{parseFloat(otherAmount).toLocaleString()}</strong> will be automatically distributed across dues. Check the dues above to see the distribution.
                </div>
              )}
            </div>
          </div>

          {mDueList.length > 0 && (
            <div style={{
              marginTop: "24px",
              padding: "20px",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade6} 100%)`,
              borderRadius: "12px",
              border: `2px solid ${COLORS.primary_color_shade6}`,
              boxShadow: `0 4px 16px ${COLORS.primary_color_shade3}40`,
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "16px",
              }}>
                <div>
                  <p style={{ margin: "0 0 4px 0", fontSize: "14px", color: COLORS.white, opacity: 0.9 }}>
                    Total Selected Amount
                  </p>
                  <h3 style={{ margin: 0, fontSize: "28px", fontWeight: "700", color: COLORS.white }}>
                    ₹{totalPayableAmount.toLocaleString()}
                  </h3>
                </div>
                <button
                  onClick={handleSubmitfee}
                  disabled={totalPayableAmount === 0}
                  style={{
                    padding: "14px 32px",
                    background: totalPayableAmount === 0 
                      ? COLORS.grey4 || "#BDBDBD"
                      : `linear-gradient(135deg, ${COLORS.green3 || "#38B503"} 0%, ${COLORS.green4 || "#2C8D02"} 100%)`,
                    color: COLORS.white,
                    border: "none",
                    borderRadius: "10px",
                    fontSize: "16px",
                    fontWeight: "700",
                    cursor: totalPayableAmount === 0 ? "not-allowed" : "pointer",
                    boxShadow: totalPayableAmount === 0 
                      ? "none"
                      : `0 4px 12px ${COLORS.green2}60`,
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    opacity: totalPayableAmount === 0 ? 0.6 : 1,
                  }}
                  onMouseEnter={(e) => {
                    if (totalPayableAmount > 0) {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.green3}80`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (totalPayableAmount > 0) {
                      e.currentTarget.style.transform = "";
                      e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.green2}60`;
                    }
                  }}
                >
                  <i className="fa fa-money-bill-wave" />
                  Collect Now
                </button>
              </div>
            </div>
          )}

        {showFeeConfirmation === true && (
            <MdlOldDueCollectionConfirmation
              action_close={HandleClose}
              action_submit={HandleSubmit}
              netPayableAmount={totalPayableAmount}
          />
        )}

        {showPaymentStatus && lastTransactionId && (
          <MdlOldDuePaymentStatus
            show={showPaymentStatus}
            onClose={() => setShowPaymentStatus(false)}
            transactionId={lastTransactionId}
            studentId={student_id}
            sessionId={session_id}
            sessionName={classDetails?.session_name || ""}
            collectedAmount={lastCollectedAmount}
          />
        )}

          {/* Edit Due Modal */}
          {showEditModal && editingDue && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                padding: "20px",
              }}
              onClick={handleCloseEditModal}
            >
              <div
                style={{
                  background: COLORS.white,
                  borderRadius: "16px",
                  padding: "32px",
                  maxWidth: "500px",
                  width: "100%",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                  position: "relative",
                  overflow: "hidden",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Decorative background */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "200px",
                    height: "200px",
                    background: `linear-gradient(135deg, ${COLORS.primary_color_shade6}20 0%, ${COLORS.primary_color_shade4}20 100%)`,
                    borderRadius: "50%",
                    filter: "blur(40px)",
                  }}
                />

                {/* Header */}
                <div style={{ position: "relative", zIndex: 1, marginBottom: "24px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "24px",
                        fontWeight: "700",
                        color: COLORS.black8 || "#333333",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <i className="fa fa-edit" style={{ color: COLORS.primary_color_shade6, fontSize: "22px" }} />
                      Edit Old Due
                    </h3>
                    <button
                      onClick={handleCloseEditModal}
                      style={{
                        background: "transparent",
                        border: "none",
                        fontSize: "24px",
                        color: COLORS.black5 || "#7f7f7f",
                        cursor: "pointer",
                        padding: "0",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = COLORS.grey1 || "#F5F5F5";
                        e.currentTarget.style.color = COLORS.black8 || "#333333";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.color = COLORS.black5 || "#7f7f7f";
                      }}
                    >
                      <i className="fa fa-times" />
                    </button>
                  </div>
                  <div
                    style={{
                      padding: "8px 12px",
                      background: COLORS.primary_color_shade1 || "#B3E5FC",
                      borderRadius: "8px",
                      display: "inline-block",
                    }}
                  >
                    <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.primary_color_shade8 || "#0277BD" }}>
                      <i className="fa fa-calendar" style={{ marginRight: "6px" }} />
                      Session: {editingDue.session_name}
                    </span>
                  </div>
                </div>

                {/* Form */}
                <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* Amount Input */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: COLORS.black8 || "#333333",
                      }}
                    >
                      <i className="fa fa-rupee-sign" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                      Due Amount <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                    </label>
                    <input
                      type="number"
                      value={editAmount}
                      onChange={(e) => setEditAmount(e.target.value)}
                      placeholder="Enter due amount"
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "16px",
                        border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                        e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    />
                    <div style={{ marginTop: "6px", fontSize: "12px", color: COLORS.black5 || "#7f7f7f" }}>
                      Current Amount: <strong>₹{Number(editingDue.amount).toLocaleString()}</strong>
                    </div>
                  </div>

                  {/* Remark Input */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: COLORS.black8 || "#333333",
                      }}
                    >
                      <i className="fa fa-comment" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                      Remark <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                    </label>
                    <textarea
                      value={editRemark}
                      onChange={(e) => setEditRemark(e.target.value)}
                      placeholder="Enter remark or description"
                      rows={3}
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "16px",
                        border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                        outline: "none",
                        resize: "vertical",
                        fontFamily: "inherit",
                        boxSizing: "border-box",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                        e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    />
                  </div>

                  {/* Action Buttons */}
                  <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                    <button
                      onClick={handleCloseEditModal}
                      style={{
                        flex: 1,
                        padding: "14px 24px",
                        fontSize: "16px",
                        fontWeight: "600",
                        background: COLORS.grey1 || "#F5F5F5",
                        color: COLORS.black8 || "#333333",
                        border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                        borderRadius: "10px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = COLORS.grey2 || "#EEEEEE";
                        e.currentTarget.style.borderColor = COLORS.grey4 || "#BDBDBD";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = COLORS.grey1 || "#F5F5F5";
                        e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitEdit}
                      style={{
                        flex: 1,
                        padding: "14px 24px",
                        fontSize: "16px",
                        fontWeight: "700",
                        background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#039BE5"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
                        color: COLORS.white,
                        border: "none",
                        borderRadius: "10px",
                        cursor: "pointer",
                        boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.primary_color_shade4}80`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.primary_color_shade3}60`;
                      }}
                    >
                      <i className="fa fa-check-circle" />
                      Update Due
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Settle Due Modal */}
          {showSettleModal && settlingDue && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                padding: "20px",
              }}
              onClick={handleCloseSettleModal}
            >
              <div
                style={{
                  background: COLORS.white,
                  borderRadius: "16px",
                  padding: "32px",
                  maxWidth: "500px",
                  width: "100%",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                  position: "relative",
                  overflow: "hidden",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Decorative background */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "200px",
                    height: "200px",
                    background: `linear-gradient(135deg, ${COLORS.green3}20 0%, ${COLORS.green4}20 100%)`,
                    borderRadius: "50%",
                    filter: "blur(40px)",
                  }}
                />

                {/* Header */}
                <div style={{ position: "relative", zIndex: 1, marginBottom: "24px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "24px",
                        fontWeight: "700",
                        color: COLORS.black8 || "#333333",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <i className="fa fa-check-circle" style={{ color: COLORS.green4, fontSize: "22px" }} />
                      Settle Old Due
                    </h3>
                    <button
                      onClick={handleCloseSettleModal}
                      style={{
                        background: "transparent",
                        border: "none",
                        fontSize: "24px",
                        color: COLORS.black5 || "#7f7f7f",
                        cursor: "pointer",
                        padding: "0",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = COLORS.grey1 || "#F5F5F5";
                        e.currentTarget.style.color = COLORS.black8 || "#333333";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.color = COLORS.black5 || "#7f7f7f";
                      }}
                    >
                      <i className="fa fa-times" />
                    </button>
                  </div>
                  <div
                    style={{
                      padding: "8px 12px",
                      background: COLORS.primary_color_shade1 || "#B3E5FC",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.primary_color_shade8 || "#0277BD" }}>
                      <i className="fa fa-calendar" style={{ marginRight: "6px" }} />
                      Session: {settlingDue.session_name}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: "8px 12px",
                      background: COLORS.green1 || "#C8E6C9",
                      borderRadius: "8px",
                      display: "inline-block",
                    }}
                  >
                    <span style={{ fontSize: "13px", fontWeight: "600", color: COLORS.green4 || "#2C8D02" }}>
                      <i className="fa fa-rupee-sign" style={{ marginRight: "6px" }} />
                      Remaining Due: ₹{(() => {
                        const amount = Number(settlingDue.amount) || 0;
                        const settled = Number(settlingDue.settled_amount) || 0;
                        // Due = total amount - settled amount (settled_amount includes both collection and settlement)
                        return Math.max(0, amount - settled).toLocaleString();
                      })()}
                    </span>
                  </div>
                </div>

                {/* Form */}
                <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* Amount Input */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: COLORS.black8 || "#333333",
                      }}
                    >
                      <i className="fa fa-rupee-sign" style={{ marginRight: "6px", color: COLORS.green4 }} />
                      Settle Amount <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                    </label>
                    <input
                      type="number"
                      value={settleAmount}
                      onChange={(e) => setSettleAmount(e.target.value)}
                      placeholder="Enter amount to settle"
                      min="0"
                      max={(() => {
                        const amount = Number(settlingDue.amount) || 0;
                        const settled = Number(settlingDue.settled_amount) || 0;
                        // Due = total amount - settled amount (settled_amount includes both collection and settlement)
                        return Math.max(0, amount - settled);
                      })()}
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "16px",
                        border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = COLORS.green4 || "#2C8D02";
                        e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.green1}40`;
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    />
                    <div style={{ marginTop: "6px", fontSize: "12px", color: COLORS.black5 || "#7f7f7f" }}>
                      Max Amount: <strong>₹{(() => {
                        const amount = Number(settlingDue.amount) || 0;
                        const settled = Number(settlingDue.settled_amount) || 0;
                        // Due = total amount - settled amount (settled_amount includes both collection and settlement)
                        return Math.max(0, amount - settled).toLocaleString();
                      })()}</strong>
                    </div>
                    {settleAmount && parseFloat(settleAmount) > (() => {
                        const amount = Number(settlingDue.amount) || 0;
                        const settled = Number(settlingDue.settled_amount) || 0;
                        // Due = total amount - settled amount (settled_amount includes both collection and settlement)
                        return Math.max(0, amount - settled);
                      })() && (
                      <div style={{
                        marginTop: "8px",
                        padding: "8px 12px",
                        background: COLORS.red1 || "#FFEBEE",
                        border: `1px solid ${COLORS.red3 || "#EF5350"}`,
                        borderRadius: "6px",
                        color: COLORS.red7 || "#d32f2f",
                        fontSize: "13px",
                      }}>
                        <i className="fa fa-exclamation-circle" style={{ marginRight: "6px" }} />
                        Amount cannot exceed remaining due
                      </div>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                    <button
                      onClick={handleCloseSettleModal}
                      style={{
                        flex: 1,
                        padding: "14px 24px",
                        fontSize: "16px",
                        fontWeight: "600",
                        background: COLORS.grey1 || "#F5F5F5",
                        color: COLORS.black8 || "#333333",
                        border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                        borderRadius: "10px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = COLORS.grey2 || "#EEEEEE";
                        e.currentTarget.style.borderColor = COLORS.grey4 || "#BDBDBD";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = COLORS.grey1 || "#F5F5F5";
                        e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmitSettle}
                      style={{
                        flex: 1,
                        padding: "14px 24px",
                        fontSize: "16px",
                        fontWeight: "700",
                        background: `linear-gradient(135deg, ${COLORS.green3 || "#38B503"} 0%, ${COLORS.green4 || "#2C8D02"} 100%)`,
                        color: COLORS.white,
                        border: "none",
                        borderRadius: "10px",
                        cursor: "pointer",
                        boxShadow: `0 4px 12px ${COLORS.green2}60`,
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.green3}80`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.green2}60`;
                      }}
                    >
                      <i className="fa fa-check-circle" />
                      Settle Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default OldDueCollection;
